module.exports = __webpack_public_path__ + "static/06018b70.rocket.png";